import { getTestIds } from 'seagull/utils/TestIds';
import { StepsContainerDesktop } from "./StepsContainerDesktop";
import { StepsContainerMobile } from "./StepsContainerMobile";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetStepsContainerTID = parentTestId => getTestIds({
  parentTestId
});
export const StepsContainer = _ref => {
  let {
    testId,
    currentStep,
    direction,
    onBack,
    onNext,
    relationship,
    isMobile,
    statement,
    isStatementAccepted,
    onStatementChange,
    isNextDisabled,
    hideNextButton
  } = _ref;
  if (isMobile) {
    return /*#__PURE__*/_jsx(StepsContainerMobile, {
      testId: testId,
      currentStep: currentStep,
      direction: direction,
      relationship: relationship,
      statement: statement,
      isStatementAccepted: isStatementAccepted,
      onStatementChange: onStatementChange
    });
  }
  return /*#__PURE__*/_jsx(StepsContainerDesktop, {
    testId: testId,
    currentStep: currentStep,
    direction: direction,
    onBack: onBack,
    onNext: onNext,
    relationship: relationship,
    statement: statement,
    isStatementAccepted: isStatementAccepted,
    onStatementChange: onStatementChange,
    isNextDisabled: isNextDisabled,
    hideNextButton: hideNextButton
  });
};